





















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import MainTabbar from "../../general/MainTabbar.vue";

import RentalAllProducts from "./RentalAllProducts.vue";
import RentalCart from "./RentalCart.vue";
import RentalStartPopup from "./RentalStartPopup.vue";
import RentalLogin from "./RentalLogin.vue";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import RentalBookingInfoJson from "../../../shared/RentalBookingInfoJson";
import RentalBookingJson, { defaultRentalBookingJson } from "../../../shared/RentalBookingJson";

export default Vue.extend({
  name: "Rental",
  components: {
    MainTabbar,
    RentalAllProducts,
    RentalCart,
    RentalStartPopup,
    RentalLogin,
  },
  props: {
    appFrameClickedButton: Object,
    settings: Object as PropType<SettingsPublicJson | null>,
    rentalBookingInfo: Object as PropType<RentalBookingInfoJson | null>,
    clientData: Object,
    clientPassword: String,
    restrictToTypeId: Number as PropType<number | null>,
  },
  data() {
    return {
      RestClient: RestClient,
      currentTab: "RentalAllProducts",
      rentalCart: [] as RentalBookingJson[],
      isForYouth: null as boolean | null,
      showStartPopup: false as boolean,
      showLogin: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showLogin = !this.showLogin;
      if (this.showLogin == false) {
        //this.reloadData()
      }
    },

    openDetails(item: any | null) {
      this.toggleDetails();
    },
    /*** END: details view ***/

    init() {
      if (this.settings && this.settings.rentalPublicShowStartPopup) 
        this.showStartPopup = true;
    },

    changeTabContent: function (tab: string) {
      this.currentTab = tab;
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.overview) {
        if (
          this.currentTab == "RentalAllProducts" &&
          this.settings &&
          this.settings.rentalPublicShowStartPopup
        ) {
          this.showStartPopup = true;
        } else {
          this.changeTabContent("RentalAllProducts");
        }
      }

      if (this.appFrameClickedButton.account) {
        this.showLogin = true;
      }

      if (this.appFrameClickedButton.cart) {
        this.changeTabContent("RentalCart");
      }
    },

    rentalCart() {
      this.$emit("setCartAmount", this.rentalCart.length);
    },
  },
});
